import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import * as RequestActions from '../../../actions/requestActions';
import MarketMap from './MapComponent';
import { getFinancialStats, getIndustryQoutes } from '../../../api';
import { mapFetchedData, parseData } from '../../../models/market-map/data-parser';
import SocketFactory from '../../../api/socket-io';
import './index.css';


class MapPage extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      mapData:{},
      dataSource:{},
      showNA:false, 
      tickers:{},
      _socket:null
    }
    this.getMarketData = this.getMarketData.bind(this);
    this.hendleShowNA = this.hendleShowNA.bind(this);
    this.generateMarketMap = this.generateMarketMap.bind(this);
    this.socket = this.socket.bind(this);
  }



  UNSAFE_componentWillReceiveProps(newProps){
    if( newProps.lang !== this.props.lang){
      this.setState({dataSource:{}})
      this.getMarketData();
    }
  }


  componentDidMount(){
    this.getMarketData(this.state.showNA);
    this.socket();
  }

  componentWillUnmount(){
    if(this.state._socket) this.state._socket.close();
  }

  getMarketData(){
    getFinancialStats()
    .then((tickers)=>{
      getIndustryQoutes()
      .then((quotes)=>{
        this.generateMarketMap(tickers, quotes)
      })
    })
  }

  generateMarketMap(tickers, quotes){
    let mapData = mapFetchedData(tickers, quotes);
    let dataSource = parseData(mapData, this.state.showNA);
    this.setState({tickers, mapData, dataSource})
    //console.log('tickers', tickers, 'quotes', quotes)
  }

  hendleShowNA(showNA){
    let dataSource = parseData(this.state.mapData, showNA);
    this.setState({dataSource, showNA})
  }

  onMessage = (data)=>{
    console.log('message recived', data.data.length ? '' : 'but empty')
    if(data.data) {
      this.generateMarketMap(this.state.tickers, data.data)
    }
  }

  socket(){
    let _socket = new SocketFactory();
    _socket.connect('marketMapIndustryQoutes', '', this.onMessage);
    this.setState({_socket});
    //marketMapIndustryQoutes
    //marketMapFinancialStats
  }


  render() {
    const { lang } = this.props;
    const { dataSource } = this.state;
    //console.log('MapPage dataSource ---- ', dataSource)

    return (
      <div className='page-padding'>
        <MarketMap lang={lang} dataSource={dataSource} hendleShowNA={this.hendleShowNA}/>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  lang: state.request.lang
});


const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    ...RequestActions,
  }, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(MapPage);
